var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"experience-level-badge","data-level":_vm.level}},[_vm._v(" "+_vm._s(_vm.level)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }